import { connect } from "react-redux";
import { getListNguonVon } from "../../actions/NguonVon";
import { NguonVon } from "components/NguonVon";

const mapStateToProps = (state) => ({
  NguonVon: state.NguonVon,
});

const mapDispatchToProps = (dispatch) => ({
  getListNguonVon: (dataSearch) => dispatch(getListNguonVon(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NguonVon);
